/**
 * Vista: Nueva Recepción Visual
 * Incluye captura de firmas digitales y fotos
 */

import recepcionService from '../services/recepcion.service.js';
import modeloService from '../services/modelo.service.js';
import almacenService from '../services/almacen.service.js';
import tractorService from '../services/tractor.service.js';
import router from '../router/router.js';
import permisos from '../services/permissions.service.js';
import { pickImage, pickVideo } from '../utils/mediaChooser.js';
import { validarVideoInspeccion } from '../utils/videoUploader.js';
import { compressImage } from '../utils/imageCompressor.js';
import { normalizers, attachNormalizer } from '../utils/inputNormalizer.js';


import { hoyLocal } from '../utils/fechas.js';
import { danosRecepcionHtml, iniciarDanosRecepcion, leerDanosRecepcion, validarDanosRecepcion, danosParaGuardar } from '../utils/danosRecepcion.js';
// Nombre que el usuario ve, para que los errores de validación hablen de la pantalla
// y no de la base de datos.
const ETIQUETAS_CAMPO = {
    num_serie: 'Número de serie',
    marca: 'Marca',
    modelo: 'Modelo',
    fecha_recepcion: 'Fecha de recepción',
    almacen_id: 'Almacén',
    serie_motor: 'Serie del motor',
    horas_motor: 'Horas del motor',
    tiene_certificacion_ocima: 'Certificación OCIMA',
    guia_embarque: 'Guía de embarque',
    factura: 'Factura',
    pedimento: 'Pedimento',
    observaciones: 'Observaciones',
    motivo_reingreso: 'Motivo del reingreso',
};
export default {
  data: {
    almacenesActivos: [],
    loadingAlmacenes: true,
    tractorData: null,  // Datos pre-llenados del tractor
    tractorExiste: null, // null = no buscado, true = existe, false = no existe (nuevo)
    marcasDisponibles: []
  },

  async render(params) {
    // Capturar número de serie de query params si viene de Compras
    const urlParams = new URLSearchParams(window.location.search);
    this.numSeriePrefilled = urlParams.get('num_serie');

    return `
      <!-- Card principal (mismo patrón que PNC) -->
      <div class="card">
        <div class="card-header" style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 0.5rem;">
          <h2 class="card-title">Nueva Recepción Visual</h2>
          <div style="display: flex; gap: 0.5rem;">
            <button class="btn btn-secondary" onclick="router.navigate('/almacen/recepciones')">← Volver</button>
          </div>
        </div>

        <div style="padding: 1rem;">
          <!-- Búsqueda por NS -->
          <div style="border: 1px solid var(--gray-200); padding: 1.25rem; border-radius: 8px; margin-bottom: 1.5rem; background: var(--bg-secondary); box-shadow: 0 1px 3px rgba(0,0,0,0.08);">
            <div style="margin-bottom: 1rem;">
              <h4 style="margin: 0 0 0.25rem; font-size: 0.95rem; font-weight: 600;">Buscar por número de serie</h4>
              <p style="margin: 0; font-size: 0.8rem; color: var(--gray-500);">Ingrese el número de serie del tractor para cargar sus datos automáticamente</p>
            </div>
            <div style="display: flex; gap: 0.75rem; align-items: center;">
              <input type="text" name="num_serie" class="form-input" placeholder="Ej: TE354-2026-0127" required style="flex: 1;" />
              <button type="button" class="btn btn-primary" onclick="window.nuevaRecepcionView.buscarPorNumSerie()" style="white-space: nowrap;">Buscar</button>
            </div>
            <div id="tractorResult" style="margin-top: 1rem;"></div>
          </div>

          <form id="recepcionForm" onsubmit="event.preventDefault(); window.nuevaRecepcionView.guardar();">


          <!-- Formulario principal (se muestra al encontrar tractor, igual que PNC) -->
          <div id="formularioPrincipal" style="display: none;">

          <!-- Contexto detectado (OC o reingreso) -->
          <div id="contextoRecepcion" style="display: none; margin-bottom: 1rem;"></div>

          <!-- Motivo de reingreso (solo si tipo=reingreso) -->
          <div id="motivoReingresoSection" style="display: none; margin-bottom: 1rem;">
            <div style="border: 1px solid var(--warning, #f59e0b); background: #fff9eb; border-radius: 8px; padding: 1rem;">
              <div style="font-weight: 600; color: #92400e; margin-bottom: 0.75rem; font-size: 1rem;">🔄 Reingreso detectado</div>
              <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-600); margin-bottom: 0.25rem; display: block; font-weight: 600;">Motivo *</label>
              <select name="motivo_reingreso" id="motivoReingresoSelect" class="form-select" required>
                <option value="">-- Seleccionar motivo --</option>
                <option value="expo_demo">Expo / Demo</option>
                <option value="falta_pago">Devolución por falta de pago</option>
                <option value="garantia">Devolución por garantía</option>
                <option value="prestamo">Préstamo devuelto</option>
                <option value="otro">Otro</option>
              </select>
            </div>
          </div>

          <!-- Datos del tractor -->
          <div id="datosTractorSection">
            <div style="border: 1px solid var(--gray-200); border-radius: 8px; padding: 1.25rem; margin-bottom: 1.5rem;">
              <h4 style="margin: 0 0 1rem; font-size: 0.8rem; font-weight: 700; text-transform: uppercase; letter-spacing: 1px; color: var(--primary); display: flex; align-items: center; gap: 0.75rem;">Datos del Tractor <span style="flex: 1; height: 2px; background: var(--gray-200);"></span></h4>
              <div id="datosBasicosContainer">
                <div class="rec-grid-2col" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 0.5rem;">
                  <div>
                    <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Marca *</label>
                    <input type="text" name="marca" id="marcaInput" class="form-input" required readonly style="background: var(--gray-50);"/>
                    <select name="marca_select" id="marcaSelect" class="form-select" style="display: none;">
                      <option value="">Seleccionar marca...</option>
                    </select>
                  </div>
                  <div>
                    <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Modelo *</label>
                    <input type="text" name="modelo" id="modeloInput" class="form-input" required readonly style="background: var(--gray-50);"/>
                    <select name="modelo_select" id="modeloSelect" class="form-select" style="display: none;" disabled>
                      <option value="">Seleccione primero una marca...</option>
                    </select>
                  </div>
                </div>
                <div class="rec-grid-2col" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 0.5rem; margin-top: 0.5rem;">
                  <div>
                    <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Fecha de Recepción *</label>
                    <input type="date" name="fecha_recepcion" class="form-input" required />
                  </div>
                  <div>
                    <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Almacén *</label>
                    <select name="almacen_id" id="almacenSelect" class="form-select" required>
                      <option value="">Seleccionar almacén...</option>
                    </select>
                  </div>
                </div>

                <!-- Datos del motor. Sólo aparecen cuando la unidad es nueva: en un
                     reingreso el tractor ya existe y volver a preguntarlos invita a
                     contradecir lo que ya está guardado. -->
                <div id="camposTractorNuevo" style="display: none; margin-top: 0.75rem; padding-top: 0.75rem; border-top: 1px dashed var(--gray-300);">
                  <div style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.5rem;">Datos del motor (unidad nueva)</div>
                  <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 0.5rem;">
                    <div>
                      <label style="font-size: 0.7rem; color: var(--gray-500);">Serie del motor</label>
                      <input type="text" name="serie_motor" class="form-input" style="text-transform: uppercase;" />
                    </div>
                    <div>
                      <label style="font-size: 0.7rem; color: var(--gray-500);">Horas del motor</label>
                      <input type="number" name="horas_motor" class="form-input" value="0" min="0" step="0.01" />
                    </div>
                  </div>
                  <label style="display: flex; align-items: center; gap: 0.5rem; margin-top: 0.5rem; font-size: 0.85rem;">
                    <input type="checkbox" name="tiene_certificacion_ocima" />
                    Tiene certificación OCIMA
                  </label>
                </div>
              </div>
            </div>
          </div>

          <!-- Documentación -->
          <div style="border: 1px solid var(--gray-200); border-radius: 8px; padding: 1.25rem; margin-bottom: 1.5rem;">
            <h4 style="margin: 0 0 1rem; font-size: 0.8rem; font-weight: 700; text-transform: uppercase; letter-spacing: 1px; color: var(--primary); display: flex; align-items: center; gap: 0.75rem;">Documentación <span style="flex: 1; height: 2px; background: var(--gray-200);"></span></h4>

            <!-- Certificado de Origen -->
            <div style="display: flex; align-items: center; justify-content: space-between; padding: 0.6rem 0.75rem; border: 1px solid var(--gray-200); border-radius: var(--border-radius); background: white; margin-bottom: 1rem;">
              <label style="display: flex; align-items: center; gap: 0.5rem; cursor: pointer; margin: 0;">
                <input type="checkbox" name="certificado_origen" id="newCertificadoOrigen" />
                <span style="font-size: 0.875rem;">Certificado de Origen</span>
              </label>
              <span id="newCertBadge"></span>
            </div>

            <!-- Guía, Factura -->
            <div class="rec-grid-2col" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 0.5rem;">
              <div>
                <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Guía de Embarque</label>
                <input type="text" name="guia_embarque" class="form-input" style="text-transform: uppercase;" />
              </div>
              <div>
                <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Factura</label>
                <input type="text" name="factura" class="form-input" style="text-transform: uppercase;" />
              </div>
            </div>
            <!-- Pedimento -->
            <div style="margin-top: 0.5rem;">
              <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Pedimento</label>
              <input type="text" name="pedimento" class="form-input" style="text-transform: uppercase;" />
            </div>
          </div>

          <!-- Tabs Navigation -->
          <div class="rec-tabs-bar">
            <button type="button" class="rec-tab active" onclick="window.nuevaRecepcionView.showFormTab('checklist')">
              Checklist
            </button>
            <button type="button" class="rec-tab" onclick="window.nuevaRecepcionView.showFormTab('observaciones')">
              Observaciones
            </button>
            <button type="button" class="rec-tab" onclick="window.nuevaRecepcionView.showFormTab('evidencias')">
              Evidencias
            </button>
          </div>

          <!-- Tab: Checklist -->
          <div id="formtab-checklist" class="rec-form-tab-content">

          <!-- Sección: Checklist de Recepción (AMX-AL-FR-02_R4) -->
          <div class="recepcion-section">
            <div class="section-content">
              <div class="checklist-grid">
                <label class="checkbox-label">
                  <input type="checkbox" name="documentacion" />
                  <span>Documentación</span>
                </label>
                <label class="checkbox-label">
                  <input type="checkbox" name="tren_motriz" />
                  <span>Tren Motriz</span>
                </label>
                <label class="checkbox-label">
                  <input type="checkbox" name="emblema" />
                  <span>Emblema</span>
                </label>
                <label class="checkbox-label">
                  <input type="checkbox" name="estabilizadores" />
                  <span>Estabilizadores</span>
                </label>
                <label class="checkbox-label">
                  <input type="checkbox" name="salpicaderas" />
                  <span>Salpicaderas</span>
                </label>
                <label class="checkbox-label">
                  <input type="checkbox" name="mofle_escape" />
                  <span>Mofle o Escape</span>
                </label>
                <label class="checkbox-label">
                  <input type="checkbox" name="llantas_traseras" />
                  <span>Llantas Traseras</span>
                </label>
                <label class="checkbox-label">
                  <input type="checkbox" name="barra_tiro" />
                  <span>Barra de Tiro</span>
                </label>
                <label class="checkbox-label">
                  <input type="checkbox" name="llantas_delanteras" />
                  <span>Llantas Delanteras</span>
                </label>
                <label class="checkbox-label">
                  <input type="checkbox" name="brazos_levante" />
                  <span>Brazos de Levante</span>
                </label>
                <label class="checkbox-label">
                  <input type="checkbox" name="caja_herramientas" />
                  <span>Caja de Herramientas</span>
                </label>
                <label class="checkbox-label">
                  <input type="checkbox" name="contrapesos_traseros" />
                  <span>Contrapesos Traseros</span>
                </label>
                <label class="checkbox-label">
                  <input type="checkbox" name="caja_tornilleria" />
                  <span>Caja de Tornillería</span>
                </label>
                <label class="checkbox-label">
                  <input type="checkbox" name="contrapesos_delanteros" />
                  <span>Contrapesos Delanteros</span>
                </label>
                <label class="checkbox-label">
                  <input type="checkbox" name="bastidor_bateria" />
                  <span>Bastidor con Batería</span>
                </label>
                <label class="checkbox-label">
                  <input type="checkbox" name="rops_toldo" />
                  <span>ROPS / Toldo</span>
                </label>
                <label class="checkbox-label">
                  <input type="checkbox" name="eje_delantero" />
                  <span>Eje Delantero</span>
                </label>
                <label class="checkbox-label">
                  <input type="checkbox" name="cabina" />
                  <span>Cabina</span>
                </label>
                <label class="checkbox-label">
                  <input type="checkbox" name="cubierta_pto" />
                  <span>Cubierta de PTO</span>
                </label>
              </div>
            </div>
          </div>

          </div><!-- /formtab-checklist -->

          <!-- Tab: Observaciones -->
          <div id="formtab-observaciones" class="rec-form-tab-content" style="display: none;">
            <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px;">
              <div class="form-group">
                <label class="form-label">Estado General *</label>
                <select name="estado_general" id="nrEstadoGeneral" class="form-select" required>
                  <option value="excelente">Excelente</option>
                  <option value="bueno" selected>Bueno</option>
                  <option value="regular">Regular</option>
                  <option value="malo">Malo</option>
                </select>
              </div>

              ${danosRecepcionHtml('nr', {})}

              <div class="form-group">
                <label class="form-label">Observaciones (nota)</label>
                <textarea name="observaciones" class="form-input" rows="3" placeholder="Observaciones..."></textarea>
                <p style="font-size: 0.75rem; color: var(--gray-400); margin: 0.25rem 0 0;">Es sólo una nota: no abre PNC. Los daños van arriba, en «¿Hay daño?».</p>
              </div>

            </div>
          </div>

          <!-- Tab: Evidencias -->
          <div id="formtab-evidencias" class="rec-form-tab-content" style="display: none;">

          <!-- Sección: Evidencias -->
          <div class="recepcion-section">
            <div class="section-content">

              <!-- Fotos de Identificación -->
              <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem;">
                <h4 style="margin: 0 0 1rem; font-size: 0.95rem;">Fotos de Identificación</h4>
                <div class="rec-grid-3col" style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 1rem;">
                  <div>
                    <label class="form-label">Número de Serie</label>
                    <div id="foto-numserie-box" style="aspect-ratio: 4/3; border: 2px dashed var(--gray-300); border-radius: 8px; background: white; display: flex; align-items: center; justify-content: center; cursor: pointer; overflow: hidden;"
                         onclick="window.nuevaRecepcionView.pickFotoIdentificacion('numserie')">
                      <div style="text-align: center; color: var(--gray-400);">
                        <div style="font-size: 2rem;">📷</div>
                        <p style="margin: 0.5rem 0 0; font-size: 0.8rem;">Toque para capturar</p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <label class="form-label">Número de Motor</label>
                    <div id="foto-nummotor-box" style="aspect-ratio: 4/3; border: 2px dashed var(--gray-300); border-radius: 8px; background: white; display: flex; align-items: center; justify-content: center; cursor: pointer; overflow: hidden;"
                         onclick="window.nuevaRecepcionView.pickFotoIdentificacion('nummotor')">
                      <div style="text-align: center; color: var(--gray-400);">
                        <div style="font-size: 2rem;">📷</div>
                        <p style="margin: 0.5rem 0 0; font-size: 0.8rem;">Toque para capturar</p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <label class="form-label">Horómetro</label>
                    <div id="foto-horometro-box" style="aspect-ratio: 4/3; border: 2px dashed var(--gray-300); border-radius: 8px; background: white; display: flex; align-items: center; justify-content: center; cursor: pointer; overflow: hidden;"
                         onclick="window.nuevaRecepcionView.pickFotoIdentificacion('horometro')">
                      <div style="text-align: center; color: var(--gray-400);">
                        <div style="font-size: 2rem;">📷</div>
                        <p style="margin: 0.5rem 0 0; font-size: 0.8rem;">Toque para capturar</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Video (gateado por permiso subir_video, compartido) -->
              <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem;">
                <h4 style="margin: 0 0 1rem; font-size: 0.95rem;">Video de Inspección <span style="color: var(--danger);">*</span></h4>
                ${permisos.can('recepciones', 'subir_video') ? `
                  <button type="button" class="btn-media" onclick="window.nuevaRecepcionView.pickVideoInspeccion()">
                    <span class="btn-media-icon">🎥</span>
                    <span>Video de Inspección *</span>
                  </button>
                  <div id="video-preview"></div>
                ` : `
                  <p style="color: var(--gray-500); font-size: 0.875rem; margin: 0;">
                    El video lo subirá la persona responsable más adelante. La recepción no se podrá completar hasta que el video esté cargado.
                  </p>
                `}
              </div>

              <!-- Fotos del Tractor -->
              <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px;">
                <h4 style="margin: 0 0 1rem; font-size: 0.95rem;">Fotos del Tractor</h4>
                <div id="fotos-preview" class="fotos-grid-new"></div>
              </div>

              <input
                type="file"
                id="pdf-requisicion-input"
                accept="application/pdf"
                style="display: none;"
              />

              <button type="button" class="btn-media" onclick="document.getElementById('pdf-requisicion-input').click()" style="display: none;">
                <span class="btn-media-icon">📤</span>
                <span>Requisición PDF</span>
              </button>
              <div id="pdf-requisicion-preview"></div>

              <input
                type="file"
                id="pdf-orden-compra-input"
                accept="application/pdf"
                style="display: none;"
              />

              <button type="button" class="btn-media" onclick="document.getElementById('pdf-orden-compra-input').click()" style="display: none;">
                <span class="btn-media-icon">📤</span>
                <span>Orden de Compra PDF</span>
              </button>
              <div id="pdf-orden-compra-preview"></div>
            </div>
          </div>

          </div><!-- /formtab-evidencias -->


          <!-- Botones de Acción -->
          <div style="display: flex; gap: 1rem; justify-content: flex-end; margin-top: 1.5rem;">
            <button type="button" class="btn btn-secondary" onclick="router.navigate('/almacen/recepciones')">Cancelar</button>
            <button type="submit" class="btn btn-success" id="guardarBtn">Crear Recepción</button>
          </div>

          </div><!-- /formularioPrincipal -->
          </form>
        </div>
      </div>
    `;
  },

  showFormTab(tab) {
    document.querySelectorAll('.rec-form-tab-content').forEach(el => el.style.display = 'none');
    const target = document.getElementById(`formtab-${tab}`);
    if (target) target.style.display = 'block';

    document.querySelectorAll('.rec-tab').forEach(btn => btn.classList.remove('active'));
    document.querySelector(`.rec-tab[onclick*="'${tab}'"]`)?.classList.add('active');

    // Re-inicializar firmas al cambiar a ese tab (canvas necesita estar visible)
    if (tab === 'firmas' && this.signaturePadAlmacen) {
      setTimeout(() => {
        const canvasAlmacen = document.getElementById('firma-almacen');
        const canvasRecibio = document.getElementById('firma-recibio');
        if (canvasAlmacen && canvasRecibio) {
          const ratio = Math.max(window.devicePixelRatio || 1, 1);
          [canvasAlmacen, canvasRecibio].forEach(canvas => {
            canvas.width = canvas.offsetWidth * ratio;
            canvas.height = canvas.offsetHeight * ratio;
            canvas.getContext('2d').scale(ratio, ratio);
          });
          // Preservar datos si ya firmó
          if (!this.signaturePadAlmacen.isEmpty()) {
            const dataAlmacen = this.signaturePadAlmacen.toData();
            this.signaturePadAlmacen.clear();
            this.signaturePadAlmacen.fromData(dataAlmacen);
          }
          if (!this.signaturePadRecibio.isEmpty()) {
            const dataRecibio = this.signaturePadRecibio.toData();
            this.signaturePadRecibio.clear();
            this.signaturePadRecibio.fromData(dataRecibio);
          }
        }
      }, 50);
    }
  },

  async afterRender() {
    window.nuevaRecepcionView = this;

    // Inyectar estilos de tabs (mismo estilo que PNC)
    if (!document.getElementById('rec-tab-styles')) {
      const style = document.createElement('style');
      style.id = 'rec-tab-styles';
      style.textContent = `
        .rec-tabs-bar { display: flex; padding: 0; background: transparent; border-bottom: 2px solid #e5e7eb; margin-bottom: 1rem; }
        .rec-tab { flex: 1; padding: 0.6rem 1rem; border: none; border-bottom: 3px solid transparent; margin-bottom: -2px; background: transparent; color: #6b7280; font-size: 0.875rem; font-weight: 500; cursor: pointer; transition: all 0.2s ease; text-align: center; }
        .rec-tab:hover:not(.active) { color: #374151; border-bottom-color: #d1d5db; }
        .rec-tab.active { color: var(--primary); font-weight: 600; border-bottom-color: var(--primary); }
        @media (max-width: 640px) {
          .rec-tabs-bar { display: grid; grid-template-columns: 1fr 1fr; gap: 0.3rem; padding: 0.3rem; }
          .rec-tab { padding: 0.4rem 0.5rem; font-size: 0.75rem; }
          .rec-grid-2col { grid-template-columns: 1fr !important; }
          .rec-grid-3col { grid-template-columns: 1fr !important; }
        }
      `;
      document.head.appendChild(style);
    }

    // Inicializar fecha actual
    document.querySelector('[name="fecha_recepcion"]').value = hoyLocal();

    // Vincular evento Enter en número de serie
    const numSerieInput = document.querySelector('[name="num_serie"]');
    numSerieInput.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        this.buscarPorNumSerie();
      }
    });

    // Ocultar formulario al modificar el número de serie (debe buscar de nuevo)
    numSerieInput.addEventListener('input', () => {
      this.resetearCamposTractor();
    });

    // Normalizar inputs (sin espacios, mayúsculas en NS, solo dígitos en pedimento).
    // El attachNormalizer corre BEFORE/DURING el input, así que se ejecuta antes
    // de que el listener anterior llame a resetearCamposTractor.
    attachNormalizer(numSerieInput, normalizers.alfanumUpper);
    const pedimentoInput = document.querySelector('[name="pedimento"]');
    if (pedimentoInput) attachNormalizer(pedimentoInput, normalizers.numero);

    // Cargar almacenes activos
    await this.cargarAlmacenesActivos();

    // Configurar cascada Marca → Modelo para tractor nuevo
    const marcaSelect = document.getElementById('marcaSelect');
    marcaSelect.addEventListener('change', (e) => {
      this.cargarModelosPorMarca(e.target.value);
    });

    // Toggle del asterisco "Observaciones" + warning si baja la severidad con texto escrito
    const estadoSel = document.getElementById('nrEstadoGeneral');
    if (estadoSel) {
      estadoSel._prevValue = estadoSel.value;
      estadoSel.addEventListener('change', () => {
        const prev = estadoSel._prevValue;
        const nuevo = estadoSel.value;
        const setAsterisco = () => {};
        // C-323b: las observaciones ya no se borran al cambiar el estado general (son una nota, no el PNC)
        const txt = document.querySelector('textarea[name="observaciones"]');
        const haTexto = false;
        if (haTexto && ['regular','malo'].includes(prev) && ['bueno','excelente'].includes(nuevo)) {
          const etiquetaNuevo = nuevo === 'bueno' ? 'Bueno' : 'Excelente';
          modal.open(
            'Se eliminarán las observaciones',
            `<p style="margin:0;">Al cambiar el estado a <strong>${etiquetaNuevo}</strong>, las observaciones registradas se eliminarán. ¿Deseas continuar?</p>`,
            [
              { text: 'Cancelar', class: 'btn-secondary', onClick: () => {
                estadoSel.value = prev;
                setAsterisco(prev);
              }},
              { text: 'Continuar', class: 'btn-primary', onClick: () => {
                txt.value = '';
                estadoSel._prevValue = nuevo;
              }}
            ]
          );
          return; // No actualizar _prevValue hasta que el usuario decida
        }
        estadoSel._prevValue = nuevo;
      });
    }

    // C-323b: «¿Hay daño?»
    // C-323d: la foto de cada daño se sube al elegirla, a la carpeta de la serie
    iniciarDanosRecepcion('nr', () => {}, { numSerie: () => document.querySelector('[name="num_serie"]')?.value || '' });

    // Si viene num_serie pre-llenado, realizar la búsqueda inicial
    if (this.numSeriePrefilled) {
      numSerieInput.value = this.numSeriePrefilled;
      await this.buscarDatosTractorPorNumSerie(this.numSeriePrefilled);
    }

    // Cargar SignaturePad desde CDN
    this.loadSignaturePad();

    // Inicializar fotos (subida vía mediaChooser, ver pickFotosTractor)
    this.fotosArray = [];
    this.renderFotosGrid();

    // Inicializar video (subida vía mediaChooser, ver pickVideoInspeccion)
    this.videoFile = null;

    // Certificado de origen - badge
    const newCertCheck = document.getElementById('newCertificadoOrigen');
    const newCertBadge = document.getElementById('newCertBadge');
    if (newCertCheck && newCertBadge) {
      newCertCheck.addEventListener('change', () => {
        if (newCertCheck.checked) {
          newCertBadge.textContent = 'Recibido';
          newCertBadge.className = 'badge badge-success';
          newCertBadge.style.fontSize = '0.75rem';
        } else {
          newCertBadge.textContent = '';
          newCertBadge.className = '';
        }
      });
    }

    // Inicializar fotos de identificación (subida vía mediaChooser, ver pickFotoIdentificacion)
    this.fotoNumSerie = null;
    this.fotoNumMotor = null;
    this.fotoHorometro = null;

    // Inicializar PDFs
    this.pdfRequisicion = null;
    this.pdfOrdenCompra = null;
    document.getElementById('pdf-requisicion-input').addEventListener('change', (e) => this.handlePDF(e, 'requisicion'));
    document.getElementById('pdf-orden-compra-input').addEventListener('change', (e) => this.handlePDF(e, 'orden_compra'));
  },

  buscarPorNumSerie() {
    const numSerieInput = document.querySelector('[name="num_serie"]');
    const numSerie = numSerieInput.value.trim();
    if (numSerie) {
      this.buscarDatosTractorPorNumSerie(numSerie);
    } else {
      toast.warning('Ingrese un número de serie');
    }
  },

  resetearCamposTractor() {
    const marcaInput = document.getElementById('marcaInput');
    const modeloInput = document.getElementById('modeloInput');
    const marcaSelect = document.getElementById('marcaSelect');
    const modeloSelect = document.getElementById('modeloSelect');

    // Resetear estado
    this.data.tractorExiste = null;
    this.data.tractorData = null;

    // Ocultar formulario principal y limpiar resultado
    const form = document.getElementById('formularioPrincipal');
    if (form) form.style.display = 'none';
    const result = document.getElementById('tractorResult');
    if (result) result.innerHTML = '';

    // Resetear inputs
    marcaInput.value = '';
    modeloInput.value = '';

    // Resetear selects
    marcaSelect.value = '';
    modeloSelect.innerHTML = '<option value="">Seleccione primero una marca...</option>';
    modeloSelect.disabled = true;
  },

  formatearEstado(estado) {
    const estados = {
      'en_almacen': 'En Almacén',
      'pendiente': 'Pendiente',
      'en_transito': 'En Tránsito',
      'en_produccion': 'En Producción',
      'liberado': 'Liberado',
      'entregado': 'Entregado',
      'en_servicio': 'En Servicio'
    };
    return estados[estado] || estado;
  },

  async buscarDatosTractorPorNumSerie(numSerie) {
    const marcaInput = document.getElementById('marcaInput');
    const modeloInput = document.getElementById('modeloInput');
    const contextoDiv = document.getElementById('contextoRecepcion');
    const motivoSection = document.getElementById('motivoReingresoSection');
    const motivoSelect = document.getElementById('motivoReingresoSelect');
    const formDiv = document.getElementById('formularioPrincipal');
    const resultDiv = document.getElementById('tractorResult');

    // Reset estado
    this.data.tipoRecepcion = null;
    this.data.unidadOcId = null;
    this.data.tractorData = null;
    if (motivoSection) motivoSection.style.display = 'none';
    if (motivoSelect) { motivoSelect.value = ''; motivoSelect.required = false; }
    if (contextoDiv) { contextoDiv.style.display = 'none'; contextoDiv.innerHTML = ''; }

    if (!numSerie) {
      if (formDiv) formDiv.style.display = 'none';
      if (resultDiv) resultDiv.innerHTML = '';
      return;
    }

    try {
      const lookup = await recepcionService.lookupNumSerie(numSerie);

            if (!lookup.existe) {
                // Serie nueva: aquí NACE el tractor. Antes esto bloqueaba y mandaba a
                // registrarlo desde una Orden de Compra, pero ese módulo ya no existe.
                // `mostrarModoTractorNuevo()` ya estaba escrita; sólo no la llamaba nadie.
                if (resultDiv) {
                    resultDiv.innerHTML = `
                        <div style="padding: 0.9rem; background: #eef7ee; border: 1px solid var(--success, #2e7d32); border-radius: 8px;">
                            <strong>Unidad nueva.</strong>
                            <div style="font-size: 0.9rem; margin-top: 0.3rem; color: var(--gray-700);">
                                No hay ningún tractor con ese número de serie, así que se dará de alta
                                con esta recepción. Captura marca, modelo y los datos del motor.
                            </div>
                        </div>
                    `;
                }
                this.data.tipoRecepcion = 'compra';
                await this.mostrarModoTractorNuevo();
                this.mostrarCamposTractorNuevo(true);
                return;
            }

      // Tractor soft-deleted → ofrecer reactivarlo
      if (lookup.tipo_detectado === 'soft_deleted') {
        const fechaEliminacion = new Date(lookup.tractor.deleted_at).toLocaleDateString('es-MX', {
          year: 'numeric', month: 'long', day: 'numeric'
        });
        const reactivar = confirm(
          `El tractor ${numSerie} fue eliminado el ${fechaEliminacion}.\n\n¿Desea reactivarlo para registrar una nueva recepción?`
        );

        if (!reactivar) {
          if (resultDiv) resultDiv.innerHTML = '';
          if (formDiv) formDiv.style.display = 'none';
          toast.info('Operación cancelada');
          return;
        }

        try {
          toast.info('Reactivando tractor...');
          await tractorService.reactivar(numSerie);
          toast.success('Tractor reactivado exitosamente');
          // Volver a consultar ahora que está activo
          return await this.buscarDatosTractorPorNumSerie(numSerie);
        } catch (err) {
          console.error('Error al reactivar tractor:', err);
          toast.error('No se pudo reactivar el tractor');
          if (formDiv) formDiv.style.display = 'none';
          return;
        }
      }

      // Tractor existe — configurar según tipo detectado
      this.data.tractorData = lookup.tractor;
      marcaInput.value = lookup.tractor.marca || '';
      modeloInput.value = lookup.tractor.modelo || '';
      this.mostrarModoTractorExistente();
      this.mostrarCamposTractorNuevo(false);
      if (resultDiv) resultDiv.innerHTML = '';

      // Si hay un borrador vigente (con o sin OC), redirigir siempre al borrador
      // en vez de crear uno nuevo.
      if (lookup.borrador_id) {
        toast.info('Este tractor ya tiene una recepción iniciada. Continuando...');
        router.navigate(`/almacen/recepciones/${lookup.borrador_id}`);
        return;
      }

      if (lookup.tipo_detectado === 'compra_oc') {
        // (Redundante pero defensivo) Si borrador existe bajo la unidad OC, redirigir
        if (lookup.unidad_oc.recepcion_borrador_id) {
          toast.info(`Este tractor ya tiene una recepción iniciada. Continuando...`);
          router.navigate(`/almacen/recepciones/${lookup.unidad_oc.recepcion_borrador_id}`);
          return;
        }

        // Caso 2: viene de una OC pendiente → auto-vincular
        this.data.tipoRecepcion = 'compra';
        this.data.unidadOcId = lookup.unidad_oc.unidad_id;
        marcaInput.value = lookup.unidad_oc.marca || marcaInput.value;
        modeloInput.value = lookup.unidad_oc.modelo || modeloInput.value;

        // Si el NS viene preseteado por query param (venimos desde la OC), bloquear
        const vieneDeOC = this.numSeriePrefilled && numSerie === this.numSeriePrefilled;
        if (vieneDeOC) {
          const nsInput = document.querySelector('[name="num_serie"]');
          if (nsInput) {
            nsInput.readOnly = true;
            nsInput.style.background = 'var(--gray-50)';
          }
          const buscarBtn = nsInput?.nextElementSibling;
          if (buscarBtn && buscarBtn.tagName === 'BUTTON') {
            buscarBtn.disabled = true;
            buscarBtn.style.opacity = '0.5';
            buscarBtn.style.cursor = 'not-allowed';
          }
        }

        contextoDiv.innerHTML = `
          <div style="padding: 0.9rem; background: #eef2ff; border: 1px solid #6366f1; border-radius: 8px;">
            <div style="font-weight: 600; color: #3730a3;">📦 Recepción inicial vinculada a pedido</div>
            <div style="font-size: 0.9rem; color: var(--gray-700); margin-top: 0.25rem;">
              ${lookup.unidad_oc.pedido_folio} · ${lookup.unidad_oc.proveedor_nombre || 'Proveedor'}
            </div>
            ${vieneDeOC ? `
              <div style="font-size: 0.8rem; color: var(--gray-500); margin-top: 0.35rem;">
                El NS está bloqueado. Si es otro tractor, usa <strong>← Volver</strong> y elige la unidad correcta en el pedido.
              </div>
            ` : ''}
          </div>
        `;
        contextoDiv.style.display = 'block';
      } else if (lookup.tipo_detectado === 'reingreso') {
        // Caso 3: reingreso → pedir motivo
        this.data.tipoRecepcion = 'reingreso';
        motivoSection.style.display = 'block';
        motivoSelect.required = true;

        // El título "Reingreso detectado" vive dentro de motivoReingresoSection (unificado)
        contextoDiv.style.display = 'none';
        contextoDiv.innerHTML = '';
      }
    } catch (error) {
      console.error('Error en lookup:', error);
      toast.error('Error al consultar el NS.');
      if (formDiv) formDiv.style.display = 'none';
    }
  },

  mostrarModoTractorExistente() {
    const marcaInput = document.getElementById('marcaInput');
    const modeloInput = document.getElementById('modeloInput');
    const marcaSelect = document.getElementById('marcaSelect');
    const modeloSelect = document.getElementById('modeloSelect');

    // Mostrar formulario principal
    const form = document.getElementById('formularioPrincipal');
    if (form) form.style.display = '';

    // Mostrar inputs readonly
    marcaInput.style.display = '';
    modeloInput.style.display = '';
    marcaInput.required = true;
    modeloInput.required = true;

    // Ocultar selects
    marcaSelect.style.display = 'none';
    modeloSelect.style.display = 'none';
    marcaSelect.required = false;
    modeloSelect.required = false;
  },

  // Muestra u oculta los datos del motor. Se piden SOLO cuando la unidad es
  // nueva; en un reingreso el tractor ya existe con esos datos.
  mostrarCamposTractorNuevo(mostrar) {
      const bloque = document.getElementById('camposTractorNuevo');
      if (bloque) bloque.style.display = mostrar ? '' : 'none';
  },

  async mostrarModoTractorNuevo() {
    const marcaInput = document.getElementById('marcaInput');
    const modeloInput = document.getElementById('modeloInput');
    const marcaSelect = document.getElementById('marcaSelect');
    const modeloSelect = document.getElementById('modeloSelect');

    // Mostrar formulario principal
    const form = document.getElementById('formularioPrincipal');
    if (form) form.style.display = '';

    // Ocultar inputs readonly
    marcaInput.style.display = 'none';
    modeloInput.style.display = 'none';
    marcaInput.required = false;
    modeloInput.required = false;

    // Mostrar selects
    marcaSelect.style.display = '';
    modeloSelect.style.display = '';
    marcaSelect.required = true;
    modeloSelect.required = true;

    // Cargar marcas si no están cargadas
    if (this.data.marcasDisponibles.length === 0) {
      await this.cargarMarcas();
    }
  },

  async cargarMarcas() {
    const marcaSelect = document.getElementById('marcaSelect');

    try {
      const response = await modeloService.obtenerMarcas();
      this.data.marcasDisponibles = response.data.marcas || [];

      marcaSelect.innerHTML = `
        <option value="">Seleccionar marca...</option>
        ${this.data.marcasDisponibles.map(marca => `
          <option value="${marca}">${marca}</option>
        `).join('')}
      `;
    } catch (error) {
      console.error('Error al cargar marcas:', error);
      toast.error('Error al cargar marcas disponibles');
    }
  },

  async cargarModelosPorMarca(marca) {
    const modeloSelect = document.getElementById('modeloSelect');

    if (!marca) {
      modeloSelect.disabled = true;
      modeloSelect.innerHTML = '<option value="">Seleccione primero una marca...</option>';
      return;
    }

    try {
      modeloSelect.disabled = true;
      modeloSelect.innerHTML = '<option value="">Cargando modelos...</option>';

      const response = await modeloService.obtenerPorMarca(marca);
      const modelos = response.data.modelos || [];

      modeloSelect.innerHTML = `
        <option value="">Seleccionar modelo...</option>
        ${modelos.map(modelo => `
          <option value="${modelo.nombre}">
            ${modelo.codigo} - ${modelo.nombre}${modelo.linea ? ` · ${modelo.linea}` : ''}
          </option>
        `).join('')}
      `;

      modeloSelect.disabled = false;
    } catch (error) {
      console.error('Error al cargar modelos:', error);
      modeloSelect.innerHTML = '<option value="">Error al cargar modelos</option>';
      toast.error('Error al cargar modelos');
    }
  },

  async cargarAlmacenesActivos() {
    const select = document.getElementById('almacenSelect');
    if (!select) return;

    try {
      const response = await almacenService.listarActivos();
      this.data.almacenesActivos = response.data.almacenes || [];

      // Renderizar opciones
      select.innerHTML = `
        <option value="">Seleccionar almacén...</option>
        ${this.data.almacenesActivos.map(almacen => `
          <option value="${almacen.id}">
            ${almacen.codigo} - ${almacen.nombre}${almacen.ubicacion ? ` (${almacen.ubicacion})` : ''}
          </option>
        `).join('')}
      `;

    } catch (error) {
      console.error('Error al cargar almacenes:', error);
      select.innerHTML = `
        <option value="">Error al cargar almacenes</option>
      `;
      toast.error('No se pudieron cargar los almacenes');
    } finally {
      this.data.loadingAlmacenes = false;
    }
  },

  loadSignaturePad() {
    if (typeof SignaturePad !== 'undefined') {
      this.initFirmas();
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/signature_pad/4.1.7/signature_pad.umd.min.js';
    script.onload = () => this.initFirmas();
    script.onerror = () => {
      toast.error('Error al cargar módulo de firmas. Recargue la página.');
    };
    document.head.appendChild(script);
  },

  initFirmas() {
    const canvasAlmacen = document.getElementById('firma-almacen');
    const canvasRecibio = document.getElementById('firma-recibio');

    if (!canvasAlmacen || !canvasRecibio) return;

    // Ajustar tamaño de canvas
    const resizeCanvas = (canvas) => {
      const ratio = Math.max(window.devicePixelRatio || 1, 1);
      canvas.width = canvas.offsetWidth * ratio;
      canvas.height = canvas.offsetHeight * ratio;
      canvas.getContext('2d').scale(ratio, ratio);
    };

    resizeCanvas(canvasAlmacen);
    resizeCanvas(canvasRecibio);

    this.signaturePadAlmacen = new SignaturePad(canvasAlmacen, {
      backgroundColor: 'rgb(255, 255, 255)',
      penColor: 'rgb(0, 0, 0)'
    });

    this.signaturePadRecibio = new SignaturePad(canvasRecibio, {
      backgroundColor: 'rgb(255, 255, 255)',
      penColor: 'rgb(0, 0, 0)'
    });

    // Ocultar placeholder al comenzar a firmar
    const hidePlaceholder = (canvas) => {
      const placeholder = canvas.parentElement.querySelector('.firma-placeholder');
      if (placeholder) placeholder.style.display = 'none';
    };

    canvasAlmacen.addEventListener('pointerdown', () => hidePlaceholder(canvasAlmacen));
    canvasAlmacen.addEventListener('touchstart', () => hidePlaceholder(canvasAlmacen));
    canvasRecibio.addEventListener('pointerdown', () => hidePlaceholder(canvasRecibio));
    canvasRecibio.addEventListener('touchstart', () => hidePlaceholder(canvasRecibio));
  },

  limpiarFirma(tipo) {
    if (tipo === 'almacen') {
      this.signaturePadAlmacen?.clear();
      const canvas = document.getElementById('firma-almacen');
      const placeholder = canvas?.parentElement?.querySelector('.firma-placeholder');
      if (placeholder) placeholder.style.display = '';
    } else if (tipo === 'recibio') {
      this.signaturePadRecibio?.clear();
      const canvas = document.getElementById('firma-recibio');
      const placeholder = canvas?.parentElement?.querySelector('.firma-placeholder');
      if (placeholder) placeholder.style.display = '';
    }
  },

  async pickFotoIdentificacion(tipo) {
    const file = await pickImage();
    if (!file) return;
    const compressed = await compressImage(file);
    if (tipo === 'numserie') this.fotoNumSerie = compressed;
    else if (tipo === 'nummotor') this.fotoNumMotor = compressed;
    else if (tipo === 'horometro') this.fotoHorometro = compressed;
    const box = document.getElementById(`foto-${tipo}-box`);
    const reader = new FileReader();
    reader.onload = (ev) => {
      box.innerHTML = `<img src="${ev.target.result}" style="width: 100%; height: 100%; object-fit: cover;" />`;
      box.style.border = '2px solid var(--primary)';
    };
    reader.readAsDataURL(compressed);
  },

  async pickFotosTractor() {
    const result = await pickImage({ multiple: true });
    if (!result) return;
    const files = Array.isArray(result) ? result : [result];

    for (const file of files) {
      const compressed = await compressImage(file);
      this.fotosArray.push(compressed);
      this.addFotoPreview(compressed, this.fotosArray.length - 1);
    }

    if (files.length > 0) {
      toast.success(`${files.length} foto(s) agregada(s)`);
    }
  },

  addFotoPreview(file, index) {
    this.updateFotosCounter();
    this.renderFotosGrid();
  },

  renderFotosGrid() {
    const preview = document.getElementById('fotos-preview');
    preview.innerHTML = '';

    // Agregar fotos existentes
    this.fotosArray.forEach((foto, idx) => {
      const div = document.createElement('div');
      div.className = 'foto-item';
      div.dataset.index = idx;

      const reader = new FileReader();
      reader.onload = (e) => {
        div.innerHTML = `
          <img src="${e.target.result}" alt="Foto ${idx + 1}">
          <button
            class="foto-remove"
            onclick="window.nuevaRecepcionView.removeFoto(${idx})"
            type="button"
          >×</button>
        `;
      };
      reader.readAsDataURL(foto);
      preview.appendChild(div);
    });

    // Agregar placeholders vacíos con icono de cámara
    const placeholdersNeeded = Math.max(0, 7 - this.fotosArray.length);
    for (let i = 0; i < placeholdersNeeded; i++) {
      const placeholder = document.createElement('div');
      placeholder.className = 'foto-placeholder';
      placeholder.innerHTML = '<span class="foto-placeholder-icon">📷</span>';
      placeholder.onclick = () => this.pickFotosTractor();
      preview.appendChild(placeholder);
    }

    // Botón para agregar más fotos (siempre visible)
    const addBtn = document.createElement('div');
    addBtn.className = 'foto-add-btn';
    addBtn.innerHTML = '+';
    addBtn.onclick = () => this.pickFotosTractor();
    preview.appendChild(addBtn);
  },

  updateFotosCounter() {
    const counter = document.getElementById('fotos-counter');
    if (counter) {
      counter.textContent = `${this.fotosArray.length}/7 fotos`;
    }
  },

  removeFoto(index) {
    this.fotosArray.splice(index, 1);
    this.updateFotosCounter();
    this.renderFotosGrid();
  },

  async pickVideoInspeccion() {
    const file = await pickVideo();
    if (!file) return;

    // Validación compartida (única fuente de verdad en videoUploader.js).
    // Aquí el video se DIFIERE: se guarda en this.videoFile y se sube al
    // guardar toda la recepción (aún no existe el id para persistirlo).
    const { ok, duration, error } = await validarVideoInspeccion(file);
    if (!ok) {
      toast.error(error);
      return;
    }

    this.videoFile = file;
    this.showVideoPreview(file, duration);
    toast.success('Video cargado exitosamente');
  },

  showVideoPreview(file, duration) {
    const preview = document.getElementById('video-preview');
    const videoURL = URL.createObjectURL(file);
    const minutes = Math.floor(duration / 60);
    const seconds = Math.floor(duration % 60);
    const sizeInMB = (file.size / (1024 * 1024)).toFixed(2);

    preview.innerHTML = `
      <div class="video-preview-container" style="border: 2px solid var(--primary); border-radius: 8px; padding: 1rem; background: var(--gray-50);">
        <div style="display: flex; gap: 1rem; align-items: center;">
          <video
            src="${videoURL}"
            controls
            style="max-width: 200px; border-radius: 4px;"
          ></video>
          <div style="flex: 1;">
            <p style="margin: 0.5rem 0;"><strong>📁 Archivo:</strong> ${file.name}</p>
            <p style="margin: 0.5rem 0;"><strong>⏱️ Duración:</strong> ${minutes}:${seconds.toString().padStart(2, '0')}</p>
            <p style="margin: 0.5rem 0;"><strong>💾 Tamaño:</strong> ${sizeInMB} MB</p>
            <button
              type="button"
              class="btn btn-sm btn-danger"
              onclick="window.nuevaRecepcionView.removeVideo()"
              style="margin-top: 0.5rem;"
            >
              🗑️ Eliminar Video
            </button>
          </div>
        </div>
      </div>
    `;
  },

  removeVideo() {
    this.videoFile = null;
    document.getElementById('video-preview').innerHTML = '';
    toast.info('Video eliminado');
  },

  async handlePDF(event, tipo) {
    const file = event.target.files[0];
    if (!file) return;

    // Validar tipo
    if (file.type !== 'application/pdf') {
      toast.error('Solo se permiten archivos PDF');
      event.target.value = '';
      return;
    }

    // Validar tamaño (10MB)
    const maxSize = 10 * 1024 * 1024;
    if (file.size > maxSize) {
      toast.error('El PDF supera el tamaño máximo de 10MB');
      event.target.value = '';
      return;
    }

    // Guardar archivo según tipo
    if (tipo === 'requisicion') {
      this.pdfRequisicion = file;
      this.showPDFPreview(file, 'requisicion');
    } else if (tipo === 'orden_compra') {
      this.pdfOrdenCompra = file;
      this.showPDFPreview(file, 'orden_compra');
    }

    toast.success('PDF cargado exitosamente');
  },

  showPDFPreview(file, tipo) {
    const previewId = tipo === 'requisicion' ? 'pdf-requisicion-preview' : 'pdf-orden-compra-preview';
    const preview = document.getElementById(previewId);
    const sizeInMB = (file.size / (1024 * 1024)).toFixed(2);
    const nombre = tipo === 'requisicion' ? 'Requisición' : 'Orden de Compra';

    preview.innerHTML = `
      <div class="pdf-preview-container" style="border: 2px solid var(--success); border-radius: 8px; padding: 1rem; background: var(--gray-50); margin-top: 0.5rem;">
        <div style="display: flex; align-items: center; gap: 1rem;">
          <div style="font-size: 2rem;">📄</div>
          <div style="flex: 1;">
            <p style="margin: 0.25rem 0; font-weight: 600;">${nombre}</p>
            <p style="margin: 0.25rem 0; font-size: 0.85rem; color: var(--gray-600);">
              ${file.name} (${sizeInMB} MB)
            </p>
          </div>
          <button
            type="button"
            class="btn btn-sm btn-danger"
            onclick="window.nuevaRecepcionView.removePDF('${tipo}')"
          >
            🗑️
          </button>
        </div>
      </div>
    `;
  },

  removePDF(tipo) {
    if (tipo === 'requisicion') {
      this.pdfRequisicion = null;
      document.getElementById('pdf-requisicion-preview').innerHTML = '';
      document.getElementById('pdf-requisicion-input').value = '';
      toast.info('PDF de requisición eliminado');
    } else if (tipo === 'orden_compra') {
      this.pdfOrdenCompra = null;
      document.getElementById('pdf-orden-compra-preview').innerHTML = '';
      document.getElementById('pdf-orden-compra-input').value = '';
      toast.info('PDF de orden de compra eliminado');
    }
  },

  async guardar() {
    const guardarBtn = document.getElementById('guardarBtn');
    guardarBtn.disabled = true;
    guardarBtn.innerHTML = 'Guardando...';
    this._showProgress('Preparando datos...');

    try {
      // Validar que el lookup haya determinado un tipo de recepción válido
      if (!this.data.tipoRecepcion) {
        toast.error('Busque el número de serie antes de continuar');
        guardarBtn.disabled = false;
        guardarBtn.innerHTML = 'Crear Recepción';
        return;
      }

      // Recopilar datos del formulario
      const form = document.getElementById('recepcionForm');
      const formData = new FormData(form);
      const data = {};

      // Campos de texto
      for (const [key, value] of formData.entries()) {
        if (value !== '') {
          data[key] = value;
        }
      }

      // Tractor siempre debe existir (el lookup bloquea si no existe)
      const marcaInput = document.getElementById('marcaInput');
      const modeloInput = document.getElementById('modeloInput');
      // En modo "unidad nueva" marca y modelo se eligen en los SELECTS: los inputs
      // readonly estan ocultos y vacios. Leer siempre del control que este visible,
      // o marca y modelo viajan vacias y la API responde 400.
      const marcaSel = document.getElementById('marcaSelect');
      const modeloSel = document.getElementById('modeloSelect');
      const usaSelects = marcaSel && marcaSel.style.display !== 'none';
      data.marca = usaSelects ? (marcaSel.value || '').trim() : marcaInput.value;
      data.modelo = usaSelects ? ((modeloSel && modeloSel.value) || '').trim() : modeloInput.value;

      // Agregar num_serie (está fuera del form, en el buscador)
      data.num_serie = document.querySelector('[name="num_serie"]').value.trim();

      // Tipo de recepción y vínculos según detección del lookup
      data.tipo_recepcion = this.data.tipoRecepcion || 'compra';
      if (this.data.tipoRecepcion === 'compra' && this.data.unidadOcId) {
        data.pedido_compra_detalle_unidad_id = this.data.unidadOcId;
      }
      if (this.data.tipoRecepcion === 'reingreso') {
        const motivo = document.getElementById('motivoReingresoSelect').value;
        if (!motivo) {
          toast.error('Selecciona el motivo del reingreso');
          guardarBtn.disabled = false;
          guardarBtn.innerHTML = 'Crear Recepción';
          return;
        }
        data.motivo_reingreso = motivo;
      }

      // C-323b: «¿Hay daño?» viaja como hay_dano + danos_detalle (no como el radio del formulario)
      delete data.nrHayDano;
      const danosRec = leerDanosRecepcion('nr');
      const errorDanos = validarDanosRecepcion(danosRec);
      if (errorDanos) {
        this._hideProgress && this._hideProgress();
        this.showFormTab && this.showFormTab('observaciones');
        toast.error(errorDanos);
        guardarBtn.disabled = false;
        guardarBtn.innerHTML = 'Crear Recepción';
        return;
      }
      data.hay_dano = danosRec.hay_dano;
      data.danos_detalle = danosParaGuardar(danosRec.danos_detalle);

      // Eliminar campos que no deben ir en la recepción
      delete data.marca_select;
      delete data.modelo_select;
      delete data.motivo_reingreso_raw;

      // Checkbox certificado_origen (campo individual)
      data.certificado_origen = formData.has('certificado_origen');

      // Checklist de Recepción AMX-AL-FR-02_R4 (objeto JSON)
      const checklistFields = [
        'documentacion', 'emblema', 'salpicaderas',
        'llantas_traseras', 'llantas_delanteras', 'caja_herramientas',
        'caja_tornilleria', 'bastidor_bateria', 'eje_delantero', 'cubierta_pto',
        'tren_motriz', 'estabilizadores', 'mofle_escape', 'barra_tiro',
        'brazos_levante', 'contrapesos_traseros', 'contrapesos_delanteros',
        'rops_toldo', 'cabina'
      ];

      data.checklist = {};
      checklistFields.forEach(name => {
        data.checklist[name] = formData.has(name);
        delete data[name]; // Eliminar del nivel raíz
      });

      // Subir fotos de identificación (si las hay)
      if (this.fotoNumSerie) {
        this._showProgress('Subiendo foto núm. serie...');
        data.foto_num_serie_url = await recepcionService.subirFoto(
          this.fotoNumSerie,
          `${data.num_serie}_num_serie.jpg`,
          data.num_serie
        );
      }
      if (this.fotoNumMotor) {
        this._showProgress('Subiendo foto núm. motor...');
        data.foto_num_motor_url = await recepcionService.subirFoto(
          this.fotoNumMotor,
          `${data.num_serie}_num_motor.jpg`,
          data.num_serie
        );
      }
      if (this.fotoHorometro) {
        this._showProgress('Subiendo foto del horómetro...');
        data.foto_horometro_url = await recepcionService.subirFoto(
          this.fotoHorometro,
          `${data.num_serie}_horometro.jpg`,
          data.num_serie
        );
      }

      // Subir firmas (si las hay)
      if (this.signaturePadAlmacen && !this.signaturePadAlmacen.isEmpty()) {
        this._showProgress('Subiendo firmas...');
        const firmaAlmacenBlob = await this.toBlob(this.signaturePadAlmacen);
        data.responsable_almacen_firma_url = await recepcionService.subirFirma(
          firmaAlmacenBlob,
          `${data.num_serie}_firma_almacen.png`,
          data.num_serie
        );
      }

      if (this.signaturePadRecibio && !this.signaturePadRecibio.isEmpty()) {
        const firmaRecibioBlob = await this.toBlob(this.signaturePadRecibio);
        data.recibio_firma_url = await recepcionService.subirFirma(
          firmaRecibioBlob,
          `${data.num_serie}_firma_recibio.png`,
          data.num_serie
        );
      }

      // Subir fotos del tractor (si las hay)
      if (this.fotosArray.length > 0) {
        this._showProgress('Subiendo fotos del tractor...');
        data.fotos = await recepcionService.subirMultiplesFotos(
          this.fotosArray,
          `${data.num_serie}`,
          (progress) => {
            this._showProgress(`Subiendo fotos del tractor... ${progress.percentage}%`);
          }
        );
      }

      // Subir video (si lo hay)
      if (this.videoFile) {
        this._showProgress('Subiendo video de inspección...');
        data.video_url = await recepcionService.subirVideo(
          this.videoFile,
          `${data.num_serie}_inspeccion.${this.videoFile.name.split('.').pop()}`,
          data.num_serie
        );
      }

      // Subir PDFs (si los hay)
      if (this.pdfRequisicion) {
        this._showProgress('Subiendo documentos PDF...');
        data.pdf_requisicion_url = await recepcionService.subirDocumento(
          this.pdfRequisicion,
          `${data.num_serie}_requisicion.pdf`
        );
      }

      if (this.pdfOrdenCompra) {
        data.pdf_orden_compra_url = await recepcionService.subirDocumento(
          this.pdfOrdenCompra,
          `${data.num_serie}_orden_compra.pdf`
        );
      }

      // Crear recepción ahora que tenemos todas las URLs
      this._showProgress('Guardando recepción...');
      const resultado = await recepcionService.crear(data);

      toast.success('¡Recepción guardada exitosamente!');

      // Redirigir al detalle para seguir editando
      const recepcionId = resultado.data?.id || resultado.id;
      router.navigate(`/almacen/recepciones/${recepcionId}`);

    } catch (error) {
      console.error('Error completo:', error);
      console.error('Error response:', error.response);
      console.error('Error message:', error.message);

      // La API dice exactamente que campo falla y por que (details). Mostrarlo:
      // «Error de validación» a secas no le sirve a nadie para corregir.
      let errorMsg = error.message || 'Error al guardar recepción';
      if (Array.isArray(error.details) && error.details.length) {
          const partes = error.details.map(d => {
              const campo = ETIQUETAS_CAMPO[d.field] || d.field;
              let motivo = d.message || '';
              if (/is not allowed to be empty|is required/i.test(motivo)) motivo = 'falta capturarlo';
              else if (/must be a number/i.test(motivo)) motivo = 'debe ser un número';
              else if (/greater than or equal/i.test(motivo)) motivo = 'no puede ser negativo';
              else if (/length must be less than or equal to (\d+)/i.test(motivo)) {
                  motivo = 'es demasiado largo (máximo ' + RegExp.$1 + ' caracteres)';
              }
              return campo + ': ' + motivo;
          });
          errorMsg = 'Revisa ' + (partes.length > 1 ? 'estos datos' : 'este dato') + ' — ' + partes.join('; ');
      }
      toast.error(errorMsg);
    } finally {
      this._hideProgress();
      guardarBtn.disabled = false;
      guardarBtn.innerHTML = 'Crear Recepción';
    }
  },

  _showProgress(message) {
    let overlay = document.getElementById('progressOverlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'progressOverlay';
      overlay.style.cssText = 'position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255,255,255,0.9); display: flex; flex-direction: column; align-items: center; justify-content: center; z-index: 9999;';
      overlay.innerHTML = `
        <div class="spinner" style="margin-bottom: 1rem;"></div>
        <p id="progressMessage" style="font-size: 1rem; font-weight: 600; color: var(--gray-700);"></p>
      `;
      document.body.appendChild(overlay);
    }
    document.getElementById('progressMessage').textContent = message;
  },

  _hideProgress() {
    const overlay = document.getElementById('progressOverlay');
    if (overlay) overlay.remove();
  },

  async toBlob(signaturePad) {
    const dataURL = signaturePad.toDataURL('image/png');
    const response = await fetch(dataURL);
    return response.blob();
  }
};
